import { useRouter } from "next/router";
import axios from "axios";
import { useState, useLayoutEffect, useEffect } from "react";
import { Container, Carousel, Row, Col, Button } from "react-bootstrap";
import styles from "../../../styles/Home.module.css";
import Subnav from "../../../components/CategoriesComponents/Subnav";
import CategoryCompaniesCard from "../../../components/companyCard";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Spinner from "react-bootstrap/Spinner";
import Link from "next/link";
import WritersCard from "../../../components/CategoriesComponents/WritersCard";
import { useUser } from "@auth0/nextjs-auth0";
import graphcmsRequest from "../../api/graphcms";
import HeadComponent from "../../../components/HeadComponent";
import mongoapi from "@/pages/api/mongoapi";
import jwt from "jsonwebtoken";
import { callBackendApi } from "@/utils/common";
const initialState = {
  category: {},
  content: "",
  category_companies: [],
  subnav: [],
  likesData: [],
};
function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}
function Category(props) {
  const [state, updateState] = useState(initialState);
  const [width, height] = useWindowSize();
  const [loading, setloading] = useState(false);
  const user = useUser().user;
  const userLoading = useUser().isLoading;
  const userId = user ? user.sub.split("|")[1] : "null";
  const router = useRouter();
  const metaTitle = `${
    props.category && props.category.name
  } - Modern Data Stack`;
  useEffect(() => {
    if (user) {
      (async function () {
        const userId = user.sub.split("|")[1];
        const userAuthType = user.sub.split("|")[0];
        var userDetails;
        const query = `
                     query MyQuery {
            userDetail(where: {userId: "${userId}"}) {
              email
              emailVerified
              authType
              name
            }
          }
                      `;
        userDetails = await graphcmsRequest("post", query);
        if (
          (userDetails && userDetails.data.data.userDetail === null) ||
          userDetails.data.data.userDetail.emailVerified === false
        ) {
          router.push("/welcome");
        }
      })();
    }
  }, [user]);
  return (
    <div
      className={styles.container}
      style={{
        // backgroundColor: props.nav || props.loading ? "#dcd5ca" : "#fff7ea",
        // opacity: props.nav || props.loading ? "0.4" : "1",
        backgroundColor: "#fff7ea",
      }}
    >
      <HeadComponent
        title={`${metaTitle}`}
        url={"https://www.moderndatastack.xyz"}
        description={`${props.category && props.category.shortDescription}`}
      />
      <div
        style={{
          // backgroundColor: props.nav || props.loading ? "#dcd5ca" : "#FEEBDC",
          backgroundColor: "#FEEBDC",
        }}
        className="mb-5 pb-4 pt-5"
      >
        <Container>
          <Row className="justify-content-start">
            <Col sm={8} md={8} lg={10}>
              {props.width > 575 && (
                <p>
                  <span>
                    <Link href="/categories">
                      <a
                        style={{
                          color: "#f66640",
                          textDecoration: "none",
                          opacity: "0.6",
                        }}
                      >
                        Categories
                      </a>
                    </Link>
                  </span>
                  <span
                    className="m-1"
                    style={{
                      color: "#f66640",
                      textDecoration: "none",
                      opacity: "0.6",
                    }}
                  >
                    {">"}
                  </span>
                  <span
                    className=""
                    style={{
                      color: "#f66640",
                      textDecoration: "none",
                    }}
                  >
                    {props.category.name}
                  </span>
                </p>
              )}
              <Row className="justify-content-start">
                <Col md={12} xs={12} className="justify-content-start">
                  <h1 id="categoryName"> {props.category.name}</h1>
                </Col>
                {props.width < 575 && (
                  <Col
                    sm={4}
                    md={4}
                    lg={4}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: props.width < 575 ? "center" : "end",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#fff7ea",
                        border: "0.1px solid #f77855",
                        color: "#f77855",
                        borderRadius: "50%",
                        maxHeight: "150px",
                        maxWidth: "150px",
                        minHeight: "150px",
                        minWidth: "150px",
                        display: "table",
                        padding: "10px",
                        textAlign: "end",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={props.category.iconUrl}
                        width="100px"
                        height="100px"
                      ></img>
                    </div>
                  </Col>
                )}
                <Col md={10} xs={12}>
                  <p
                    className="text-muted font-size-lg"
                    style={{ textAlign: "start", fontSize: "18px" }}
                  >
                    {props.category.shortDescription}
                  </p>
                </Col>
              </Row>
            </Col>
            {props.width > 575 && (
              <Col
                sm={4}
                md={4}
                lg={2}
                style={{
                  display: "flex",
                  justifyContent: props.width < 575 ? "center" : "end",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff7ea",
                    border: "0.1px solid #f77855",
                    color: "#f77855",
                    borderRadius: "50%",
                    maxHeight: "150px",
                    maxWidth: "150px",
                    minHeight: "150px",
                    minWidth: "150px",
                    display: "table",
                    padding: "10px",
                    textAlign: "end",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={props.category.iconUrl}
                    width="100px"
                    height="100px"
                  ></img>
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </div>
      <div style={{ minHeight: "500px" }}>
        {props.category &&
        props.category.name &&
        props.category.name.length > 0 ? (
          <Container className="justify-content-md-center">
            <Row className="justify-content-md-center mb-5">
              <Col md={12} sm={12} className="my-auto">
                {props.category.writer === "true" ? (
                  <Row>
                    <Col lg={3} md={12} sm={12} xs={12}>
                      <div
                        className="mt-2"
                        style={{
                          position: "-webkit-sticky",
                          position: "sticky",
                          top: "0",
                        }}
                      >
                        <h4>Jump To :</h4>
                        <Subnav subnav={props.subnav} />
                        {width > 995 && (
                          <WritersCard category={props.category} />
                        )}
                      </div>
                    </Col>
                    <Col lg={9} md={12} sm={12} xs={12}>
                      <div
                        dangerouslySetInnerHTML={{ __html: props.content }}
                      />
                    </Col>
                  </Row>
                ) : (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: props.content }} />
                  </>
                )}
              </Col>
            </Row>
            {props.category.writer === "true" && width < 995 && (
              <Row className="justify-content-center mt-5 mb-5">
                <Col className="d-flex justify-content-center">
                  <WritersCard category={props.category} />
                </Col>
              </Row>
            )}
            <Row className="justify-content-start mb-3 ">
              <Col md={9} sm={12} className="my-auto">
                <h2 className="mt-5" style={{ textAlign: "start" }}>
                  Featured Companies
                </h2>
                <p
                  className="font-size-lg text-start text-muted "
                  style={{ textAlign: "start", fontSize: "18px" }}
                >
                  Here are some amazing companies in the {props.category.name}.
                </p>
              </Col>
            </Row>
            <Row className="mb-5 justify-content-start ">
              {props.vendors.slice(0, 4).map((company) => (
                <Col
                  md={6}
                  sm={6}
                  lg={4}
                  xl={3}
                  xs={12}
                  className="p-3"
                  key={company._id}
                >
                  <CategoryCompaniesCard company={company} />
                </Col>
              ))}
            </Row>
            <Row className="justify-content-md-center mb-3">
              <Col md={9} sm={12} className="my-auto">
                <Link
                  href="/companies/[id]"
                  as={`/companies/${props.category.slug}`}
                >
                  <a style={{ color: "#f66640" }}>
                    <p
                      className="font-size-lg "
                      style={{ textAlign: "center", color: "#f66640" }}
                    >
                      View More
                    </p>
                  </a>
                </Link>
              </Col>
            </Row>
          </Container>
        ) : (
          <Row
            className="justify-content-center"
            style={{ marginTop: "250px", minHeight: "1000px" }}
          >
            <Col
              md={2}
              sm={2}
              xs={2}
              className="d-flex justify-content-center"
              style={{ color: "red" }}
            >
              <Spinner animation="border" style={{ color: "#f66640" }} />
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
}
export default Category;
export const getServerSideProps = async (context) => {
  const category = (
    await mongoapi("get", `categories/${context.query.id.toLowerCase()}`)
  ).data.data;
  const subnav = category.content.match(/<h3>(.*?)<\/h3>/g).map(function (val) {
    return val.replace(/<\/?h3>/g, "");
  });
  const cookie = await context.req.cookies["userToken"];
  const user = jwt.decode(cookie);
  const currentUserLikes = await callBackendApi({
    method: "get",
    url: "/like",
    params: { email: user?.email },
  });
  const likeData = currentUserLikes.data.data;
  let idRef = 1;
  const companyIds = category.vendors.map(({ vendorID }) => vendorID.slug);
  category.content = category.content
    .replace(/<h3/g, function (x) {
      let tag =
        '<h3 id="' +
        idRef.toString() +
        '" style="font-weight: 600;font-size: 27px;line-height: 27px;" ';
      idRef = idRef + 1;
      return tag;
    })
    .replace(/<h4/g, function (x) {
      var tag =
        '<h4 id="' +
        idRef.toString() +
        '" style="font-weight: 500;font-size: 16px;line-height: 27px;" ';
      idRef = idRef + 1;
      return tag;
    });
  const categoryCompanies = category.vendors.map(({ vendorID }) => vendorID);
  let likeArray = [];
  let vendorsData;
  if (user) {
    likeArray = likeData.map((like) => like.vendorId);
    vendorsData = categoryCompanies.map((company) => {
      if (likeArray.includes(company._id)) {
        company.liked = true;
      } else {
        company.liked = false;
      }
      return company;
    });
  } else {
    vendorsData = categoryCompanies;
  }

  return {
    props: {
      category,
      subnav,
      vendors: vendorsData
        ? vendorsData.sort((a, b) => b.countLikes - a.countLikes)
        : [],
      content: category.content,
    },
  };
};
